import "./_pagenotfound.scss";

export default function PageNotFound(){
  return (
    <div id="pagenotfound">
      <h1>ERRO 404</h1>
      <h2>Página não Encontrada</h2>
      <h6>Parece que a página que você está procurando foi movida ou nunca existiu.<br/>
      Certifique-se que digitou o endereço corretamente ou seguiu um link válido.</h6>
    </div>
  );
}